<app-access-manager [namespace]="namespace">

  @if (this.doOnboard) {
  <app-page-header
    [iconType]="'Location'"
    [text]="'Businesses'"
    [clickable]="true"
    (onClick)="btnCancelOnboard_click()"
  ></app-page-header>
  }

<div>
  <div [hidden]="!this.doOnboard">
    <app-merchant-onboarding
      #onboardingForm
      (newMerchantId)="handleMerchantOnboarded($event)"
    ></app-merchant-onboarding>
    <!-- <div style="margin-top: 20px">
      <input
        type="button"
        value="Cancel onboarding"
        class="btn-soft"
        (click)="this.btnCancelOnboard_click()"
      />
    </div> -->
  </div>
  <div #merchantInformation [hidden]="this.doOnboard" stlye="background-color:red;">
    <!-- <div style="margin-bottom: 20px" [hidden]="!allowAddLocation" style="background-color:blue;">
      <input
        type="button"
        value="Onboard a business"
        style="vertical-align: middle; margin: auto 0%"
        class="btn-core"
        (click)="btnNewMerchant_click()"
      />
    </div> -->
    <div
      id="merchantSearch"
      style="margin-bottom: 15px"
      [hidden]="merchant != undefined"
    >
      <app-filterable-table
        #merchantTable
        [tableView]="tableView"
        [title]="'Businesses'"
        [toolbarButtonText]="canCreateMerchants ? 'New Business' : ''"
        [options]="merchantTableOptions"
        (toolbarButtonClick)="canCreateMerchants ? btnNewMerchant_click() : null"
      ></app-filterable-table>
    </div>
  </div>
</div>
</app-access-manager>